import { z } from 'zod';

export const permalinkSchema = z.object({
  id: z.number(),
  redirectId: z.string(),
  url: z.string(),
  createdAt: z.string(),
});

export type Permalink = z.infer<typeof permalinkSchema>;
